import * as React from 'react';
const CustomDnbWallet = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.29 29.55" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M27.92 13.81V9.26a2.75 2.75 0 0 0-2.65-2.67H24m3.9 7.22H22a1.24 1.24 0 0 0-1.25 1.26V19A1.23 1.23 0 0 0 22 20.25h6.54A1.24 1.24 0 0 0 29.79 19v-3.93a1.24 1.24 0 0 0-1.25-1.26zM24 6.59l-1.54-5.18a1.17 1.17 0 0 0-1.71-.79L7 6.59m17 0H7m20.92 13.82v6a2.75 2.75 0 0 1-2.65 2.67H3.15a2.75 2.75 0 0 1-2.65-2.7V9.26a2.75 2.75 0 0 1 2.65-2.67H7"
          className="custom_dnb_wallet_svg__cls-1"
        />
        <path
          d="M24 18.37a1.26 1.26 0 1 0-1.24-1.26A1.25 1.25 0 0 0 24 18.37"
          className="custom_dnb_wallet_svg__cls-1"
        />
      </g>
    </g>
  </svg>
);
export default CustomDnbWallet;
